import { useEffect, useState } from "react"
import Cookies from 'js-cookie'

export const CookieConsentModal = props => {
    const [analyticsConsent, setAnalyticsConsent] = useState(Cookies.get('cookie-analytics') ? Cookies.get('cookie-analytics') == 'true' : true)
    const [displayConsent, setDisplayConsent] = useState(false)
    const [cookieConsentExists, setCookieConsentExists] = useState(Cookies.get('cookie-consent') != null)

    const handleAcceptCookies = () => {
        Cookies.set('cookie-consent', 'true', { expires: 365 })
        Cookies.set('cookie-analytics', `${analyticsConsent}`, { expires: 365 })
        setDisplayConsent(false)
        setCookieConsentExists(true)
    }

    useEffect(() => {
        document.addEventListener('displayCookieConsent', e => {
            setDisplayConsent(true)
        })
    }, [])

    useEffect(() => {
        setCookieConsentExists(Cookies.get('cookie-consent') != null)
    }, [displayConsent])

    return (
        (!cookieConsentExists || displayConsent) ? <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 transition-opacity">
                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>
                <div className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start">
                            <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-blue-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                                <svg className="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <h3 className="text-lg font-medium leading-6 text-gray-900 font-display" id="modal-headline">
                                    Cookies & Privacy
                                </h3>
                                <div className="mt-2">
                                    <p className="mb-2 text-sm leading-5 text-gray-500">
                                        This website uses cookies to ensure you get the best experience on our website.
                                    </p>
                                    <p className="mb-2 text-sm leading-5 text-gray-500">
                                        In order to use our services, please consent to these cookie settings by reviewing, tailoring and accepting them:
                                    </p>
                                    <div className="mb-2 text-sm leading-5 text-gray-500">
                                        <div className='flex items-center mb-2'>
                                            <div className='grow'>
                                                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Strictly necessary cookies</label> - These cookies are essential so that you can move around the website and use its features. Without these cookies services you have asked for cannot be provided.
                                            </div>
                                            <div>
                                                <input className="h-5 bg-gray-300 bg-no-repeat bg-contain rounded-full shadow-sm appearance-none cursor-pointer w-9 focus:outline-none disabled:bg-gray-400 disabled:text-gray-600 disabled:hover:bg-gray-400 disabled:hover:text-gray-600" type="checkbox" role="switch" checked={true} disabled={true} />
                                            </div>
                                        </div>
                                        <div className='flex items-center mb-2'>
                                            <div className='grow'>
                                                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Analytics</label> are used to understand how visitors interact with the website and help us to improve the performance of Ideate.Live. We are using cookies to track visitor behaviour and to improve the website.
                                            </div>
                                            <div>
                                                <input className="h-5 bg-gray-300 bg-no-repeat bg-contain rounded-full shadow-sm appearance-none cursor-pointer w-9 focus:outline-none" type="checkbox" role="switch" checked={analyticsConsent} onChange={() => setAnalyticsConsent(!analyticsConsent)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex px-4 py-3 bg-gray-50 sm:px-6">
                        <button
                            type="button" onClick={() => handleAcceptCookies()}
                            className="inline-flex justify-center w-full idtn-btn-primary-elevated-md">
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </div> : null
    )
}